import { connect } from 'react-redux';
import Permanent from '../../components/permanentStuff/Permanent';
import { fetchPermanentStaff, fetchDivisions } from '../../actions/personnel'
import * as LKactions from '../../actions/lk';
import * as actionsUMK from "../../actions/umk";


const mapStateToProps = (state) => (
    // TODO  TOKEN НЕ ПРИХОДИЛ
// const mapStateToProps = ({ personnel, lk: {data, photo}, props}, auth, ) => (
//     {
//     user: data,
//     pagesCount: personnel.pagesCount,
//     data: personnel.permanentStaff,
//     token: auth.token,
//     divisions: personnel.divisions
// });

    {
    user: state.lk.data,
    pagesCount: state.personnel.pagesCount,
    totalCount: state.personnel.totalCount,
    data: state.personnel.permanentStaff,
    token: state.auth.token,
    divisions: state.personnel.divisions,
    loading: state.personnel.isLoading,
    status: state.personnel.selectedStatus
});

const mapDispatchToProps = (dispatch) => ({
    fetchPermanentStaff: (pageNumber, string, division, status) => dispatch(fetchPermanentStaff(pageNumber, string, division, status)),
    fetchDivisions: () => dispatch(fetchDivisions()),
    didMount: () => dispatch(LKactions.lk()) && dispatch(LKactions.photo()) && dispatch(actionsUMK.umk()),

});

export default connect(mapStateToProps, mapDispatchToProps)(Permanent);
